/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React from "react";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";
import { VideoStory } from "../story-templates/video";
import { BlankStory } from "../story-templates/blank";
import PropTypes from "prop-types";
import "./story.m.css";

export class StoryPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  doAnalytics(story) {
    const { registerPageView } = require("@quintype/framework/client/analytics");
    registerPageView({ type: "story-page", story: story }, `/${story.slug}`);
  }

  render() {
    return this.props.data.story.sections[0].slug !== "magissues" ? (
      <InfiniteStoryBase
        {...this.props}
        render={storyProps => StoryPageContent(storyProps, this.props.config)}
        loadItems={storyPageLoadItems}
        onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
        onInitialItemFocus={item => this.doAnalytics(item.story)}
      />
    ) : (
      <BlankStory
        story={this.props.data.story}
        config={this.props.config}
        preview={true}
        relatedStories={this.props.data.relatedStories}
        trendingStories={this.props.data.trendingStories}
      />
    );
  }
}

export function StoryPageContent({ story, relatedStories, index, preview = false, trendingStories }, config) {
  if (story["story-template"] === "video") {
    return (
      <VideoStory
        story={story}
        config={config}
        preview={true}
        relatedStories={index === 0 ? relatedStories : []}
        trendingStories={trendingStories}
      />
    );
  } else {
    return (
      <BlankStory
        story={story}
        config={config}
        preview={true}
        relatedStories={index === 0 ? relatedStories : []}
        trendingStories={trendingStories}
      />
    );
  }
}

StoryPageContent.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  relatedStories: PropTypes.array,
  index: PropTypes.number,
  trendingStories: PropTypes.array,
  preview: PropTypes.boolean
};

const FIELDS =
  "id,headline,slug,url,hero-image-s3-key,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,author-name,author-id,sections,story-template,cards,tags,authors";

function storyPageLoadItems(pageNumber) {
  return fetch(
    `/api/v1/collections/curated-story-list?item-type=story&item-fields=${FIELDS}&limit=5&offset=${5 * pageNumber}`
  )
    .then(response => {
      return response.json();
    })
    .then(response => {
      if (!response.items) {
        console.error("No stories found. Make sure you created a collection called `curated-story-list`!");
      }
      return response.items.map(item => ({ story: item.story, relatedStories: [] }));
    });
}

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story
  })
);
